import { defineMessage, defineMessages } from 'react-intl';
import { UpsellModalContentCodes } from '../../constants/upsell-modal-content-codes';

export const messages = defineMessages({
  starterPlanBullets: {
    defaultMessage:
      '<li>Unlimited store connections</li>' +
      '<li>Automated rate shopping</li>' +
      '<li>Basic automation rules</li>' +
      '<li>Reporting</li>' +
      '<li>Email support</li>',
    description: 'Bullet points describing the features available on the Starter plan',
    id: 'ArATFF',
  },
  standardPlanBullets: {
    defaultMessage:
      '<li>Unlimited automation and custom rules</li>' +
      '<li>Combine and split orders and shipments</li>' +
      '<li>Branded tracking page</li>' +
      '<li>Bundles, lot tracking, and inventory sync</li>' +
      '<li>Phone support</li>',
    description: 'Bullet points describing the features available on the Standard plan',
    id: 'TGxnQm',
  },
  premiumPlanBullets: {
    defaultMessage:
      '<li>Auto Split</li>' +
      '<li>Advanced analytics and reporting</li>' +
      '<li>Advanced inventory & warehouse management</li>' +
      '<li>Cubiscan and ODBC</li>' +
      '<li>Dedicated Account Manager</li>',
    description: 'Bullet points describing the features available on the Premium plan',
    id: 'Nh7Sd6',
  },
});

export const shippingStrategiesNewFreemiumBullets = defineMessage({
  defaultMessage:
    '<li>Save time looking for the best rates by comparing shipping services automatically. Rate Shopper can save your team 30sec -1min per order!</li>' +
    '<li>Upgrade to customize Rate Shopper for any scenario. Choose which shipping services to consider.</li>' +
    '<li>Ensure timely deliveries by using our time in transit feature when comparing services.</li>' +
    '<li>Favor one service when prices are close? Set up a Service Preference so that Rate Shopper chooses that service based on your criteria.</li>' +
    '<li>Favor one service when prices are close? Set up a Service Preference so that Rate Shopper chooses that service based on your criteria.</li>',
  id: 'D72h5Y',
  description: 'Add-on data (bullet points, extended description) user will see when describing Rate Shopper in the add-on modal or tile',
});

export const upsellModalContent = {
  [UpsellModalContentCodes.FulfillmentProviderBundle]: defineMessages({
    name: {
      defaultMessage: 'ShipStation 3PL',
      description: 'Add-on short name user will see when describing ShipStation 3PL in the add-on modal or tile',
      id: '0MfbRb',
    },
    description: {
      defaultMessage: 'Receive orders from your clients to efficiently manage their fulfillment',
      description: 'Add-on data (description) user will see when describing ShipStation 3PL in the add-on modal or tile',
      id: 'yhUG0i',
    },
    tagline: {
      defaultMessage: 'Provide the Best Fulfillment Service for Your Clients with ShipStation 3PL',
      description: 'Add-on data (tagline) user will see when describing ShipStation 3PL in the add-on modal or tile',
      id: 'KkJQ9i',
    },
    trialTagline: {
      defaultMessage: 'Try ShipStation 3PL',
      id: '4U323U',
      description:
        'Add-on data (tagline) user will see when describing ShipStation 3PL in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Invite any number of clients to send fulfillment orders from their ShipStation account to yours</li>' +
        '<li>Automatically send tracking details to your clients and their stores upon shipment</li>' +
        "<li>Print labels using your clients' carrier accounts and packing slip templates (optional)</li>" +
        "<li>Maintain your clients' branding in customer shipping confirmation emails</li>",
      description:
        'Add-on data (bullet points, extended description) user will see when describing ShipStation 3PL in the add-on modal or tile',
      id: '6r0bS5',
    },
    redirectTitle: {
      defaultMessage: '{icon} Searching for a 3PL Partner?',
      id: 'U026Fc',
      description: 'Add-on data (redirect title) user will see when describing ShipStation 3PL in the add-on modal',
    },
    redirectText: {
      defaultMessage: '<a>Request access to our Fulfillment Network</a>',
      description: 'Add-on data (redirect text) user will see when describing ShipStation 3PL in the add-on modal',
      id: '3J5M6Z',
    },
  }),
  [UpsellModalContentCodes.DropShip]: defineMessages({
    name: {
      defaultMessage: 'Dropship Manager',
      description: 'Add-on short name user will see when describing Dropship Manager in the add-on modal or tile',
      id: 'Pxy8eS',
    },
    description: {
      defaultMessage: 'Connect with your ShipStation vendors to automate your order delegation',
      description: 'Add-on data (description) user will see when describing Dropship Manager in the add-on modal or tile',
      id: 'Zl6+n+',
    },
    tagline: {
      defaultMessage: 'Manage Your Vendor Network with Dropship Manager',
      description: 'Add-on data (tagline) user will see when describing Dropship Manager in the add-on modal or tile',
      id: 'QXONYG',
    },
    trialTagline: {
      defaultMessage: 'Try Dropship Manager',
      id: 'NyQQJa',
      description:
        'Add-on data (tagline) user will see when describing Dropship Manager in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Invite any number of vendors to connect their ShipStation account to yours</li>' +
        '<li>Delegate orders to vendors manually or with Automation Rules</li>' +
        '<li>Allow vendors to use your carrier accounts to print shipping labels (optional)</li>' +
        '<li>Ensure your customers receive your branded shipping confirmation emails & packing slips</li>' +
        '<li>View insights and reports about your drop-shipped orders</li>',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Dropship Manager in the add-on modal or tile',
      id: 'M7lrgy',
    },
  }),

  [UpsellModalContentCodes.Cubiscan]: defineMessages({
    name: {
      defaultMessage: 'Cubiscan',
      description: 'Add-on short name user will see when describing Cubiscan in the add-on modal or tile',
      id: 'IHKKWW',
    },
    description: {
      defaultMessage: 'Import weights and dimensions from a Cubiscan dimensioner',
      description: 'Add-on data (description) user will see when describing Cubiscan in the add-on modal or tile',
      id: '6JiU2O',
    },
    tagline: {
      defaultMessage: 'Import Weight & Dimensions with Cubiscan Dimensioners',
      description: 'Add-on data (tagline) user will see when describing Cubiscan in the add-on modal or tile',
      id: 'Kd/K/H',
    },
    trialTagline: {
      defaultMessage: 'Connect a Cubiscan Dimensioner',
      id: 'L4EcLO',
      description:
        'Add-on data (tagline) user will see when describing Cubiscan in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Remove human error by scanning and weighing packages with Cubiscan</li>' +
        '<li>Import weight and dimensions with a barcode scan</li>' +
        '<li>Avoid additional shipping fees by ensuring accurate shipment details every time</li>',
      description: 'Add-on data (bullet points, extended description) user will see when describing Cubiscan in the add-on modal or tile',
      id: '8zPVY1',
    },
  }),

  [UpsellModalContentCodes.ODBC]: defineMessages({
    name: {
      defaultMessage: 'ShipStation ODBC',
      description: 'Add-on short name user will see when describing ShipStation ODBC in the add-on modal or tile',
      id: 'liclaQ',
    },
    description: {
      defaultMessage: 'Connect and configure your custom ODBC order source with ShipStation',
      description: 'Add-on data (description) user will see when describing ShipStation ODBC in the add-on modal or tile',
      id: 'RoBzzB',
    },
    tagline: {
      defaultMessage: 'Connect Your Custom Data Source Using ODBC',
      description: 'Add-on data (tagline) user will see when describing ShipStation ODBC in the add-on modal or tile',
      id: 'micrtB',
    },
    trialTagline: {
      defaultMessage: 'Connect a Custom Order Source',
      id: 'e69lL9',
      description:
        'Add-on data (tagline) user will see when describing ShipStation ODBC in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Centralize and manage multiple ODBC data sources</li>' +
        '<li>Manage how order data is imported into ShipStation using custom queries</li>' +
        '<li>Post tracking numbers and shipment details back to your custom order sources</li>' +
        '<li>Professional implementation services available. Please contact Sales for more information.</li>',
      id: 'QM5bn4',
      description:
        'Add-on data (bullet points, extended description) user will see when describing ShipStation ODBC in the add-on modal or tile',
    },
  }),

  [UpsellModalContentCodes.ProductBundles]: defineMessages({
    name: {
      defaultMessage: 'Product Bundles',
      description: 'Add-on short name user will see when describing Product Bundles in the add-on modal or tile',
      id: 'FOp0jO',
    },
    description: {
      defaultMessage: 'Group multiple products together in a single bundle ',
      description: 'Add-on data (description) user will see when describing Product Bundles in the add-on modal or tile',
      id: 'sk/9zA',
    },
    tagline: {
      defaultMessage: 'Create Product Bundles to Sell Multiple Products Together',
      description: 'Add-on data (tagline) user will see when describing Product Bundles in the add-on modal or tile',
      id: 'xwZjvC',
    },
    trialTagline: {
      defaultMessage: 'Try Product Bundles',
      id: 'XHMLlx',
      description:
        'Add-on data (tagline) user will see when describing Product Bundles in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Create a Bundled Product that contains multiple individual product SKUs</li><li>Customize Pick Lists and Packing Slips to show either component SKUs or bundle SKUs</li><li>Track Inventory for all component products when sold as a bundle</li>',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Product Bundles in the add-on modal or tile',
      id: 'PGGqGt',
    },
  }),

  [UpsellModalContentCodes.ShippingStrategies]: defineMessages({
    name: {
      defaultMessage: 'Rate Shopper',
      id: 'fyT0tG',
      description: 'Add-on short name user will see when describing Rate Shopper in the add-on modal or tile',
    },
    description: {
      defaultMessage: 'Automatically compare services and get the lowest rate every time.',
      id: 'KZpH2s',
      description: 'Add-on data (description) user will see when describing Rate Shopper in the add-on modal or tile',
    },
    tagline: {
      defaultMessage: 'Get the Best Rate Every Time with Rate Shopper',
      id: 'wbRw6m',
      description: 'Add-on data (tagline) user will see when describing Rate Shopper in the add-on modal or tile',
    },
    trialTagline: {
      defaultMessage: 'Try Rate Shopper',
      id: 'WHUCl9',
      description:
        'Add-on data (tagline) user will see when describing Rate Shopper in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Automatically compare rates from all carriers to select the lowest rate for every order</li>' +
        '<li>Create and define Rate Shopper with your preferred services</li>' +
        '<li>Apply to your shipments ad hoc, in bulk, or with automation</li>',
      id: 'Ke8Lx+',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Rate Shopper in the add-on modal or tile',
    },
  }),

  [UpsellModalContentCodes.AutoSplit]: defineMessages({
    name: {
      defaultMessage: 'Auto-Split',
      id: 'ErDMHC',
      description: 'Add-on short name user will see when describing Auto Split in the add-on modal or tile',
    },
    description: {
      defaultMessage: 'Split items into separate shipments based on product-specific settings.',
      id: 'dbu04C',
      description: 'Add-on data (description) user will see when describing Auto Split in the add-on modal or tile',
    },
    tagline: {
      defaultMessage: 'Speed Up Your Fulfillment Process with Automatic Order Splitting',
      id: 'u0Rwyi',
      description: 'Add-on data (tagline) user will see when describing Auto-Split in the add-on modal or tile',
    },
    trialTagline: {
      defaultMessage: 'Try Automatic Order Splitting',
      id: 'oQBISf',
      description:
        'Add-on data (tagline) user will see when describing Auto-Split in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Automatically split orders into multiple shipments based on product settings</li>' +
        '<li>Set products to always ship alone or to split based on item quantity</li>',
      id: 'zAbcQ1',
      description: 'Add-on data (bullet points, extended description) user will see when describing Auto-Split in the add-on modal or tile',
    },
  }),

  [UpsellModalContentCodes.BrandedDomains]: defineMessages({
    name: {
      defaultMessage: 'Branded Domains',
      id: 'Zgy7ZF',
      description: 'Feature short name user will see when describing Branded Domains as a feature.',
    },
    description: {
      defaultMessage: 'Personalize notification emails by using your branded email address as the sender',
      id: 'CK7HZ/',
      description: 'Add-on data (description) user will see when describing Branded Domains in the add-on modal or tile',
    },
  }),

  [UpsellModalContentCodes.InventorySync]: defineMessages({
    name: {
      defaultMessage: 'Inventory Sync',
      id: 'XshZuK',
      description: 'Feature short name user will see when describing Inventory Sync as a feature.',
    },
    description: {
      defaultMessage: 'Sync available inventory counts to all of your connected stores',
      id: 'BGqcmX',
      description: 'Add-on data (description) user will see when describing Inventory Sync in the add-on modal or tile',
    },
    tagline: {
      defaultMessage: 'Sync your inventory counts to your connected stores',
      id: 'jI5CSF',
      description: 'Add-on data (tagline) user will see when describing Inventory Sync in the add-on modal or tile',
    },
    trialTagline: {
      defaultMessage: 'Try Inventory Sync',
      id: 'JWbDF+',
      description:
        'Add-on data (tagline) user will see when describing Inventory Sync in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Prevent over-selling inventory from out of date inventory counts</li>' +
        '<li>Easily configure which stores receive updated inventory counts from ShipStation</li>' +
        '<li>New "committed" inventory count reflects items assigned to all open orders</li>' +
        '<li>Supported selling channels: Shopify, Amazon, Etsy, WooCommerce, Walmart, Ebay, and more</li>',
      id: 'U6mep5',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Inventory Sync in the add-on modal or tile',
    },
  }),

  [UpsellModalContentCodes.ReturnRabbit]: defineMessages({
    name: {
      defaultMessage: 'Return Rabbit',
      id: 'tY7+FE',
      description: 'Feature/addOn name that we are upselling',
    },
    description: {
      defaultMessage: 'Tools to simplify returns, analyze return patterns, and retain more of your revenue.',
      id: 'hVnM7B',
      description: 'Add-on data (description) user will see for Return Rabbit in addon marketplace tile',
    },
    longFormDescription: {
      defaultMessage:
        'Create a Return Rabbit account and get free, unlimited returns and exchange software when you use our discounted carrier rates. {br} {br} Available for Shopify and WooCommerce stores.',
      id: 'Qgdvw8',
      description: 'Add-on data for a longer description user will see for Return Rabbit in upsell modal',
    },
    tagline: {
      defaultMessage: 'Return Rabbit',
      id: 'CLv8X/',
      description: 'Add-on data (tagline) user will see when describing Return Rabbit in upsell',
    },
    bullets: {
      defaultMessage:
        '<li>Retain more revenue by promoting exchanges</li>' +
        '<li>Save up to 20 minutes per return with custom and automated workflows</li>' +
        '<li>Increase customer loyalty with a hassle-free experience</li>' +
        '<li>Drive cost savings with actionable insights using enterprise dashboards and reports</li>',
      id: 'W+J+b7',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Return Rabbit in the add-on modal or tile',
    },
  }),

  [UpsellModalContentCodes.InventoryApi]: defineMessages({
    name: {
      defaultMessage: 'Inventory API',
      id: 'W1LF8t',
      description: 'Feature short name user will see when describing Inventory API as a feature.',
    },
    description: {
      defaultMessage: 'Streamline your inventory management and take control of your stock across all your sales channels.',
      id: 'QNc68+',
      description: 'Add-on data (description) user will see when describing Inventory API in the add-on modal or tile',
    },
    tagline: {
      defaultMessage: 'Connect your ShipStation account with our Inventory API',
      id: 'nTfpFS',
      description: 'Add-on data (tagline) user will see when describing Inventory API in the add-on modal or tile',
    },
    trialTagline: {
      defaultMessage: 'Try Inventory API',
      id: 'lnO4uJ',
      description:
        'Add-on data (tagline) user will see when describing Inventory API in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Access your Shipstation Inventory data with robust APIs</li>' +
        '<li>Get latest inventory stock counts and insights</li>' +
        '<li>Set stock levels and reorder points</li>' +
        '<li>Manage warehouses and warehouse bin locations</li>',
      id: 'dVrFu0',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Inventory API in the add-on modal or tile',
    },
  }),
  [UpsellModalContentCodes.ShipStationApiV2]: defineMessages({
    name: {
      defaultMessage: 'Shipping API',
      id: 'HuwXYt',
      description: 'Feature short name user will see when describing Shipping API as a feature.',
    },
    description: {
      defaultMessage: 'Integrate shipping and build delivery experiences via an API.',
      id: 'u9xBZ8',
      description: 'Add-on data (description) user will see when describing Shipping API in the add-on modal or tile',
    },
    tagline: {
      defaultMessage: 'Connect your ShipStation account with our Shipping API',
      id: 'TfmGof',
      description: 'Add-on data (tagline) user will see when describing Shipping API in the add-on modal or tile',
    },
    trialTagline: {
      defaultMessage: 'Try Shipping API',
      id: 'TKYFgD',
      description:
        'Add-on data (tagline) user will see when describing Shipping API in the add-on modal or tile when this will be a TRY FOR FREE feature',
    },
    bullets: {
      defaultMessage:
        '<li>Purchase the Shipping API add-on from your account settings</li>' +
        '<li>Generate your API key to authenticate your integration</li>' +
        '<li>Configure your sales channels to sync shipping levels automatically</li>',
      id: 'Y/rJv3',
      description:
        'Add-on data (bullet points, extended description) user will see when describing Shipping API in the add-on modal or tile',
    },
  }),
  // BillingPlan Upsells
  [UpsellModalContentCodes.BarcodeScanning]: {
    name: {
      defaultMessage: 'Barcode Scanning',
      description: 'Feature short name user will see when describing Barcode Scanning as a feature.',
      id: 'TzvBgW',
    },
    tagline: {
      defaultMessage: 'Access Scanning features and more by upgrading to the {planName} plan.',
      description: 'Tagline user will see when describing Barcode Scanning in the upsell modal',
      id: 'lMLBJp',
    },
    isNewLineupBillingPlanUpsell: true,
  },
  [UpsellModalContentCodes.DashboardsViewOnly]: {
    name: {
      defaultMessage: 'Analytics',
      description: 'Feature short name user will see when describing Analytics as a feature.',
      id: 'BFL52g',
    },
    tagline: {
      defaultMessage: 'Get business Analytics and more by upgrading to the {planName} plan.',
      description: 'Tagline user will see when describing Analytics in the upsell modal',
      id: 'Luoedd',
    },
    isNewLineupBillingPlanUpsell: true,
  },
  [UpsellModalContentCodes.EnhancedReturns]: {
    name: {
      defaultMessage: 'Enhanced Returns',
      description: 'Feature short name user will see when describing Enhanced Returns as a feature.',
      id: '6DS+uo',
    },
    tagline: {
      defaultMessage: 'Process Returns/Exchanges and get more features on the {planName} plan.',
      description: 'Tagline user will see when describing Enhanced Returns in the upsell modal',
      id: 'NvJPOh',
    },
    isNewLineupBillingPlanUpsell: true,
  },
  [UpsellModalContentCodes.ProductCatalog]: {
    name: {
      defaultMessage: 'Product Catalog',
      description: 'Feature short name user will see when describing Product Catalog as a feature.',
      id: 'iPhMRf',
    },
    tagline: {
      defaultMessage: 'Manage Products and access more features by upgrading to the {planName} plan.',
      description: 'Tagline user will see when describing Product Catalog in the upsell modal',
      id: 'dS2Ij+',
    },
    isNewLineupBillingPlanUpsell: true,
  },
};
